import { createAsyncThunk } from "@reduxjs/toolkit"
import { practiceLoaderSlice } from "./loader"
import { apiService } from "../../../features/shared/apiService"
import { practiceSlice } from "../model"
import { DataStatus } from "../../enums"
import { posthog } from "../../../posthogInstance"
import { FeatureFlag } from "../../enums/featureFlags"

export const getPracticeCompletenessData = createAsyncThunk(
  "practiceProfile/practiceCompleteness/getPracticeCompletenessData",
  async (practiceId: string, { dispatch }) => {
    dispatch(
      practiceLoaderSlice.actions.practiceDataStatusUpdated({
        practiceCompletenessDataStatus: DataStatus.LOADING,
      }),
    )

    // 20046: V3 carries the new agreement rules (standard agreement always
    // required, Knox-Keene driven by California offices rather than the billing
    // address). It builds on V2's location rule, so turning this flag on also
    // opts into V2 location semantics.
    const apiVersion = posthog.isFeatureEnabled(
      FeatureFlag.IsResetRemoveAgreements20047Enabled,
    )
      ? "3.0"
      : posthog.isFeatureEnabled(FeatureFlag.IsNoVirtualLocationEnabled)
        ? "2.0"
        : "1.0"

    try {
      const practiceCompletenessData =
        await apiService.practice.get.PRACTICE_COMPLETENESS_BY_ID({
          practiceId,
          apiVersion,
        })

      dispatch(
        practiceSlice.actions.updatePracticeCompleteness(
          practiceCompletenessData,
        ),
      )

      dispatch(
        practiceLoaderSlice.actions.practiceDataStatusUpdated({
          practiceCompletenessDataStatus: DataStatus.LOADED,
        }),
      )
      return practiceCompletenessData
    } catch (error) {
      dispatch(
        practiceLoaderSlice.actions.practiceDataStatusUpdated({
          practiceCompletenessDataStatus: DataStatus.ERROR,
        }),
      )
      console.error(error)
    }
  },
)
